import { BasicConfig } from '@react-awesome-query-builder/ui';
import { MuiConfig } from '@react-awesome-query-builder/mui';
import { addedJsonLogicOperators } from '@loyalty/shared-common';

export function makeOperators(t: (translationKey: string) => string): BasicConfig['operators'] {
  return {
    ...MuiConfig.operators,
    equal: { ...MuiConfig.operators.equal, label: t('rule.criteria.operator.equal') },
    not_equal: {
      ...MuiConfig.operators.not_equal,
      label: t('rule.criteria.operator.not_equal'),
    },
    greater: {
      ...MuiConfig.operators.greater,
      label: t('rule.criteria.operator.greater'),
    },
    greater_or_equal: {
      ...MuiConfig.operators.greater_or_equal,
      label: t('rule.criteria.operator.greater_or_equal'),
    },
    less: { ...MuiConfig.operators.less, label: t('rule.criteria.operator.less') },
    less_or_equal: {
      ...MuiConfig.operators.less_or_equal,
      label: t('rule.criteria.operator.less_or_equal'),
    },
    select_equals: {
      ...MuiConfig.operators.select_equals,
      label: t('rule.criteria.operator.select_equals'),
    },
    select_not_equals: {
      ...MuiConfig.operators.select_not_equals,
      label: t('rule.criteria.operator.select_not_equals'),
    },
    like: {
      ...MuiConfig.operators.like,
      label: t('rule.criteria.operator.like'),
      jsonLogic: 'like' as keyof typeof addedJsonLogicOperators,
    },
    not_like: {
      ...MuiConfig.operators.not_like,
      label: t('rule.criteria.operator.not_like'),
      jsonLogic: 'not_like' as keyof typeof addedJsonLogicOperators,
    },
    starts_with: {
      ...MuiConfig.operators.starts_with,
      label: t('rule.criteria.operator.starts_with'),
      jsonLogic: 'starts_with' as keyof typeof addedJsonLogicOperators,
    },
    ends_with: {
      ...MuiConfig.operators.ends_with,
      label: t('rule.criteria.operator.ends_with'),
      jsonLogic: 'ends_with' as keyof typeof addedJsonLogicOperators,
    },
    between: {
      ...MuiConfig.operators.between,
      label: t('rule.criteria.operator.between'),
    },
    not_between: {
      ...MuiConfig.operators.not_between,
      label: t('rule.criteria.operator.not_between'),
    },
    is_null: {
      ...MuiConfig.operators.is_null,
      label: t('rule.criteria.operator.is_null'),
    },
    is_not_null: {
      ...MuiConfig.operators.is_not_null,
      label: t('rule.criteria.operator.is_not_null'),
    },
    is_empty: {
      ...MuiConfig.operators.is_empty,
      label: t('rule.criteria.operator.is_empty'),
    },
    is_not_empty: {
      ...MuiConfig.operators.is_not_empty,
      label: t('rule.criteria.operator.is_not_empty'),
    },
    select_any_in: {
      ...MuiConfig.operators.select_any_in,
      label: t('rule.criteria.operator.select_any_in'),
    },
    select_not_any_in: {
      ...MuiConfig.operators.select_not_any_in,
      label: t('rule.criteria.operator.select_not_any_in'),
    },
    multiselect_equals: {
      ...MuiConfig.operators.multiselect_equals,
      label: t('rule.criteria.operator.multiselect_equals'),
    },
    multiselect_not_equals: {
      ...MuiConfig.operators.multiselect_not_equals,
      label: t('rule.criteria.operator.multiselect_not_equals'),
    },
    proximity: {
      ...MuiConfig.operators.proximity,
      label: t('rule.criteria.operator.proximity'),
    },
  };
}
